/*
 * Marketing API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.26
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';

/**
 * The KeysWebBody model module.
 * @module model/KeysWebBody
 * @version 1.0.0
 */
export class KeysWebBody {
  /**
   * Constructs a new <code>KeysWebBody</code>.
   * @alias module:model/KeysWebBody
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>KeysWebBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/KeysWebBody} obj Optional instance to populate.
   * @return {module:model/KeysWebBody} The populated <code>KeysWebBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new KeysWebBody();
      if (data.hasOwnProperty('title'))
        obj.title = ApiClient.convertToType(data['title'], 'String');
      if (data.hasOwnProperty('description'))
        obj.description = ApiClient.convertToType(data['description'], 'String');
      if (data.hasOwnProperty('enabled'))
        obj.enabled = ApiClient.convertToType(data['enabled'], 'Boolean');
    }
    return obj;
  }
}

/**
 * @member {String} title
 */
KeysWebBody.prototype.title = undefined;

/**
 * @member {String} description
 */
KeysWebBody.prototype.description = undefined;

/**
 * @member {Boolean} enabled
 */
KeysWebBody.prototype.enabled = undefined;

